/**
 * НЕ РЕДАКТИРУЙТЕ СОДЕРЖИМОЕ ЭТОГО ФАЙЛА
 * Если задача вышла за рамки генератора,
 * то отредактируйте шаблон в папке generator/templates/frontend/router.blade.php
 */
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default function createRouter() {
  const routes = [
    {
      path: "/admin/login",
      name: "login",
      component: () => import("./views/auth/login.vue"),
      meta: {
        hideComponents: true,
      },
    },
    {
      path: "/admin/password/reset",
      name: "passwordreset",
      component: () => import("./views/auth/reset.vue"),
      meta: {
        hideComponents: true,
      },
    },
    {
      path: "/admin/password/change",
      name: "password",
      component: () => import("./views/auth/password.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/profile",
      name: "profile",
      component: () => import("./views/auth/profile.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "*",
      name: "not-found",
      component: () => import("./views/PageNotFound.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/secondary-objects",
      name: "secondary-objects",
      component: () => import("./views/generated/secondary-objects/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/claim/:id?",
      name: "claims",
      component: () => import("./views/generated/claims/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/apartments/:id?",
      name: "apartments",
      component: () => import("./views/generated/apartments/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/charts/:id?",
      name: "charts",
      component: () => import("./views/charts/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/gallery-work/:id?",
      name: "gallery-works",
      component: () => import("./views/generated/gallery-works/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/info",
      name: "infos",
      component: () => import("./views/generated/infos/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/feedback",
      name: "feedback",
      component: () => import("./views/generated/feedback/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/flats/:id?",
      name: "flats",
      component: () => import("./views/generated/flats/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/category/:id?",
      name: "categories",
      component: () => import("./views/generated/categories/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/bonus/:id?",
      name: "bonuses",
      component: () => import("./views/generated/bonuses/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/object-home/:id?",
      name: "object-homes",
      component: () => import("./views/generated/object-homes/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/news/:id?",
      name: "news",
      component: () => import("./views/generated/news/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin/test",
      name: "test",
      component: () => import("./views/generated/test/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
    {
      path: "/admin",
      name: "home",
      component: () => import("./views/generated/home/index.vue"),
      meta: {
        allowedRoles: ["*"],
      },
    },
  ];
  const router = new Router({
    mode: "history",
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }
      if (to.hash) {
        return {
          selector: to.hash,
          behavior: "smooth",
        };
      }
      return { x: 0, y: 0 };
    },
    fallback: true,
    routes,
  });
  // Проверка на доступность страницы
  router.beforeEach((to, from, next) => {
    if (window.user && window.user.roles) {
      let roles = window.user.roles.map((r) => r.name);
      if (!(to.meta.allowedRoles && to.meta.allowedRoles.some((r) => r === "*" || roles.includes(r)))) {
        next(false);
        return;
      }
    }
    next();
  });

  return router;
}
